import {ReactElement, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

import {getFournisseurs} from "@/api/fournisseurs";
import CarteFournisseur from "@/components/CarteFournisseur/CarteFournisseur";
import ContentOnglet from "@/components/ContentOnglet/ContentOnglet";
import {carteFournisseur} from "@/types/fournisseur";

function Fournisseurs(): ReactElement {
  const [fournisseursList, setFournisseursList] = useState<carteFournisseur[]>(
    [],
  );
  const navigate = useNavigate();
  useEffect(() => {
    const callFournisseurs = async (): Promise<void> => {
      const fournisseurs = await getFournisseurs();
      setFournisseursList(fournisseurs);
    };
    callFournisseurs();
  });

  const FournisseursElement = fournisseursList.map(fournisseur => {
    return (
      <CarteFournisseur
        fournisseur={fournisseur}
        key={`${fournisseur.id} ${fournisseur.cofaqId}`}
        onClick={() => {
          navigate(`/fournisseur/${fournisseur.id}`);
        }}
      />
    );
  });
  return (
    <ContentOnglet title={"Fournisseurs"}>
      <div id="pageFournisseurs">{FournisseursElement}</div>
    </ContentOnglet>
  );
}

export default Fournisseurs;
